import './styles.scoped.sass'
export function LoadingSpinner (props) {
  return (
    <div className={`lds-default ${props.size || ''}`}>
      <div></div><div></div>
      <div></div><div></div>
      <div></div><div></div>
      <div></div><div></div>
      <div></div><div></div>
      <div></div><div></div>
    </div>
  )
}
